var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49273 0.5C11.9753 0.5 14 2.49 14 4.94V9.73H7.89535C7.45785 9.73 7.11192 10.07 7.11192 10.5C7.11192 10.92 7.45785 11.27 7.89535 11.27H14V16.05C14 18.5 11.9753 20.5 9.47238 20.5H4.51744C2.02471 20.5 0 18.51 0 16.06V4.95C0 2.49 2.03488 0.5 4.52762 0.5H9.49273ZM16.5402 7.0502C16.8402 6.7402 17.3302 6.7402 17.6302 7.0402L20.5502 9.9502C20.7002 10.1002 20.7802 10.2902 20.7802 10.5002C20.7802 10.7002 20.7002 10.9002 20.5502 11.0402L17.6302 13.9502C17.4802 14.1002 17.2802 14.1802 17.0902 14.1802C16.8902 14.1802 16.6902 14.1002 16.5402 13.9502C16.2402 13.6502 16.2402 13.1602 16.5402 12.8602L18.1402 11.2702H14.0002V9.7302H18.1402L16.5402 8.1402C16.2402 7.8402 16.2402 7.3502 16.5402 7.0502Z",
    fill: "#A1A1A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.81d97e4a5c36a3b94c6ca6e6649a9567.svg";
export { ForwardRef as ReactComponent };